import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';

export const SecurityDeposit = ({ insurance }) => {
  const { t } = useTranslation('loans');
  if (!insurance) return null;

  return (
    <div className="loan-info-insurance">
      <h2 className="f-22 f-500">{t('security_deposit.title')}</h2>
      {insurance ? (
        <div className="loan-info-insurance__table">
          <div className="loan-info-insurance__thead">
            <div className="loan-info-insurance__thead-col">
              {t('security_deposit.total_amount')}
            </div>
            <div className="loan-info-insurance__thead-col">
              {t('security_deposit.outstanding')}
            </div>
            <div className="loan-info-insurance__thead-col">
              {t('security_deposit.repaid_back')}
            </div>
          </div>

          <div className="loan-info-insurance__tbody">
            <div className="loan-info-insurance__tbody-row">
              <div className="loan-info-insurance__tbody-col">
                {prettyFloatMoney(insurance.total_amount)}
              </div>
              <div className="loan-info-insurance__tbody-col">
                {prettyFloatMoney(insurance.outstanding)}
              </div>
              <div className="loan-info-insurance__tbody-col">
                {prettyFloatMoney(insurance.repaid_back)}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="loan-info__empty-message f-16">{t('security_deposit.no_insurance')}</div>
      )}
    </div>
  );
};
